<template>
  <div>
    <header-ton @boxLogin="IsUsersLogin" :actived="2"></header-ton>
    <login-box :showLogin="showLogin" @closeLogin="closeBox" ref="login"></login-box>
    <div style="margin-top: 80px;">
      <img class="brand-img" src="../../../public/images/bg/8.png" height="336" alt />
    </div>

    <div class="nav">
      <div class="columna">
        <div :class="column_id == item.id ? 'li active' : 'li'" v-for="(item,index) in columnData" :key="index" @click="changeSubject(index,item.id)">
          <img class="icon" :src="'https://ytk.yitku.com/new_app/icon/icon_'+item.id+'.png'" height="46" width="46" />
          <span>{{item.ntitle}}</span>
        </div>
      </div>
      <div class="subjects">
        <span @click="changeGoodsList(0)" :class="subject_id == 0 ? 'active' : ''">全部</span>
        <span @click="changeGoodsList(item.id)" :class="subject_id == item.id ? 'active' : ''" v-for="(item,index) in subjectData" :key="index">{{item.title}}</span>
      </div>
    </div>

    <div class="box" v-loading.lock="fullscreenLoading">

      <div class="list" v-for="(item,index) in tableData" :key="index">
        <div class="thumb"><img class="icon" :src="item.thumb" height="220" width="220" /></div>
        <div class="desc">
          <div class="title"><span></span>{{item.title}}</div>
          <div class="tags">
            <span>{{item.desc}}</span>
          </div>
          <div class="bottom">
            <div class="left">
              <div class="price">￥{{item.money}}</div>
              <div class="rprice">￥{{item.price}}</div>
            </div>
            <div class="right">
              <div class="btn" @click="goDetail(item.id)">查看详情
                <img class="icon" src="../../../public/images/icon/sanjiao.png" height="12" width="10" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="paging">
        <el-pagination class="left" :page-size="limit" @current-change="handleCurrentChange" :current-page="page" background layout="total, prev, pager, next" :total="count"></el-pagination>
      </div>

    </div>

    <booter-ton></booter-ton>
  </div>
</template>
  
  <script>
import HeaderTon from "@/components/HeaderTon";
import BooterTon from "@/components/BooterTon";
import LoginBox from "@/components/LoginBox";
export default {
  components: {
    HeaderTon,
    BooterTon,
    LoginBox,
  },
  data() {
    return {
      keywords: "",
      showLogin: false,
      fullscreenLoading: true,
      column_id: 0,
      subject_id: 0,
      columnData: [],
      subjectData: [],
      tableData: [],
      page: 0,
      count: 0,
      limit: 8,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    //判断是否登录
    IsUsersLogin() {
      let token = sessionStorage.getItem("access-token");
      console.log(token);
      if (token) {
        return true;
      } else {
        this.showLogin = true;
        this.$refs.login.getMiQrCode();
        return false;
      }
    },

    closeBox(e) {
      console.log(e);
      this.showLogin = false;
    },
    //获取一级分类
    getList() {
      let that = this;
      let formData = {};
      formData.column_id = that.column_id;
      formData.limit = that.limit;
      that.axios.post("/getColumnCate", formData).then((res) => {
        if (res) {
          that.columnData = res.data;
          that.subjectData = res.data[0]["children"];
          that.column_id = res.data[0]["id"];
          console.log(res.data[0]);
          that.getGoodsList();
          //that.subject_id = that.subjectData[0]["id"];
        }
      });
    },

    changeSubject(index, ids) {
      console.log(index);
      this.column_id = ids;
      this.subjectData = this.columnData[index]["children"];
    },

    changeGoodsList(ids) {
      console.log(ids);
      this.fullscreenLoading = true;
      this.subject_id = ids;
      this.getGoodsList();
    },

    handleCurrentChange(currentPage) {
      var that = this;
      that.fullscreenLoading = true;
      that.page = currentPage;
      that.getGoodsList();
    },

    getGoodsList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.column_id = that.subject_id;
      formData.limit = that.limit;
      that.axios.post("/getGoodsList", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.fullscreenLoading = false;
        }
      });
    },

    goDetail(ids) {
      this.$router.push({
        path: "/web/shop_detail",
        query: {
          good_id: ids,
        },
      });
    },
  },
};
</script>
  
  <style>
page {
  background: #f3f8ff;
}

.nav {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  position: relative;
  top: -50px;
}

.columna {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.columna .li {
  width: 18%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-bottom: 3px solid #ffffff;
}

.columna .li:hover {
  background-color: #f2f7fe;
  color: #1167d4;
  cursor: pointer;
  border-bottom: 3px solid #1167d4;
}

.columna .active {
  background-color: #f2f7fe;
  color: #1167d4;
  cursor: pointer;
  border-bottom: 3px solid #1167d4;
}

.columna .li span {
  height: 32px;
  line-height: 32px;
}

.subjects {
  display: flex;
  align-content: flex-start;
  padding: 20px 30px;
  flex-wrap: wrap;
  min-height: 132px;
}

.subjects span {
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  background: #eff0f1;
  border-radius: 4px;
  padding: 0 12px;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}

.subjects span:hover {
  background: #badbff;
  color: #1167d4;
}

.subjects .active {
  background: #badbff;
  color: #1167d4;
}

.box {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  position: relative;
  top: -30px;
}

.box .list {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  padding: 30px;
  background: #ffffff;
}

.box .list .thumb {
  width: 220px;
  height: 220px;
  margin-right: 30px;
}

.box .list .thumb .icon {
  border-radius: 5px;
}

.box .list .desc {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 880px;
}

.box .list .desc .title {
  font-size: 16px;
  color: #333333;
  line-height: 27px;
  font-weight: bold;
  display: flex;
  flex-direction: row;
}

.box .list .desc .title span {
  width: 4px;
  height: 18px;
  background: #1167d4;
  border-radius: 2px;
  margin-right: 6px;
  margin-top: 5px;
}

.box .list .desc .tags {
  height: 42px;
  line-height: 42px;
}

.box .list .desc .tags span {
  border-radius: 5px;
  border: 1px solid #7f8ca2;
  margin-right: 10px;
  font-size: 12px;
  padding: 6px 20px;
}

.box .list .desc .bottom {
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.box .list .desc .bottom .left {
  width: 80%;
  display: flex;
  flex-direction: row;
}

.box .list .desc .bottom .left .price {
  line-height: 42px;
  color: #df1c1c;
  font-size: 28px;
  font-weight: bold;
}

.box .list .desc .bottom .left .rprice {
  color: #999999;
  font-size: 14px;
  text-decoration: line-through;
  margin-left: 10px;
  display: flex;
  align-items: flex-end;
  padding-bottom: 6px;
}

.box .list .desc .bottom .right {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box .list .desc .bottom .right .btn {
  width: 130px;
  height: 42px;
  background: linear-gradient(-90deg, #2874e0, #004bb3);
  box-shadow: 0px 0px 10px 0px rgba(14, 80, 158, 0.3);
  line-height: 42px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.box .list .desc .bottom .right .btn img {
  margin-left: 6px;
}
</style>